import React from 'react'
import Header from '../Header'
import { ColplAppSimpleTitleBar } from './ColplAppSimpleTitleBar'

export const ColplAppLayout = (params: {
  // https://stackoverflow.com/questions/30971395/difference-between-react-component-and-react-element
  header?: React.ReactElement
  titleBar?: React.ReactElement
  body: React.ReactElement
}) => {
  // Fill in components or their defaults
  const header = params.header ?? <Header />
  const titleBar = params.titleBar ?? <ColplAppSimpleTitleBar />
  const body = params.body // required

  return (
    <>
      {header}
      {titleBar}
      {body}
    </>
  )
}
